exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#systemHealthRetirever-wrapper .padding {\r\n            margin-bottom: 5%;\r\n        }\r\n\r\n#systemHealthRetirever-wrapper .color:hover {\r\n            background-color: #007eed;\r\n        }\r\n\r\n#systemHealthRetirever-wrapper .color:active {\r\n            background-color: #0084b4;\r\n        }", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./app/main/systemHealthRetriever/system-health-retriever.component.css
 ** module id = 1096
 ** module chunks = 2
 **/